import styled from 'styled-components';

interface WrapperProps {
  color?: string;
  bgColor?: string;
  paddingY?: string;
}

const Wrapper = styled.div<WrapperProps>`
  padding: ${(props) => props.paddingY || '10px'} 0;
  background-color: ${(props) => props.bgColor || 'transparent'};
  max-width: 100%;
  min-width: 0;

  &[data-bv-show='rating_summary'] {
    width: 100%;
  }

  &[data-bv-show='rating_summary'] .bv_main_container {
    width: 100%;
    max-width: 100% !important;
    min-width: 0;
  }

  &[data-bv-show='rating_summary'] .bv_main_container_row,
  &[data-bv-show='rating_summary'] .bv_main_container_row_normal {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0;
    display: flex !important;
    flex-wrap: wrap;
  }

  &[data-bv-show='rating_summary'] .bv_main_container span,
  &[data-bv-show='rating_summary'] .bv_main_container a {
    max-width: 100%;
    white-space: normal !important;
    word-break: break-word;
    overflow-wrap: anywhere;
  }

  &[data-bv-show='rating_summary'] .bv_main_container div {
    max-width: 100%;
    min-width: 0;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
  }

  &[data-bv-show='rating_summary'] .bv_main_container .bv_numReviews_text,
  &[data-bv-show='rating_summary'] .bv_main_container .bv_button_buttonMinimalist {
    color: ${(props) => props.color || '#fff'}!important;
    font-family: inherit !important;
  }
  &[data-bv-show='rating_summary'] .bv_main_container .bv_numReviews_text:hover,
  &[data-bv-show='rating_summary'] .bv_main_container .bv_button_buttonMinimalist:hover {
    color: ${(props) => props.color || '#fff'}!important;
    font-family: inherit !important;
    opacity: 0.8;
  }

  &[data-bv-show='inline_rating'] .bv_main_container .bv_text {
    color: ${(props) => props.color || '#fff'}!important;
  }
`;

interface ReviewWidgetProps {
  id: string;
  type: 'inline_rating' | 'rating_summary' | 'reviews' | 'questions';
  color?: string;
  bgColor?: string;
  paddingY?: string;
}
export const ReviewWidget = ({ id, type, color, bgColor, paddingY }: ReviewWidgetProps) => {
  return (
    <Wrapper
      data-bv-show={type}
      data-bv-product-id={id}
      color={color}
      bgColor={bgColor}
      paddingY={paddingY}
    />
  );
};
